import { Modal, Button } from "antd";

const CustomModal = ({
  visible,
  onClose,
  title,
  content,
  onSubmit,
  submitText = "Submit",
  showFooter = true,
  readOnly = false, // Set true for View mode
  onDelete,
}) => {
  const handleOk = (e) => {
    e.preventDefault(); // Mencegah form submit otomatis
    if (onSubmit) {
      const formData = new FormData(e.target);
      const values = Object.fromEntries(formData.entries());

      console.log("data e ====>", e.target);
      console.log("formData e ====>", formData);
      console.log("values e ====>", values);

      onSubmit(values);
      visible = null;
    } else if (onDelete) {
      onDelete(); // Handle delete jika ada
      visible = null;

      onClose();
    } else {
      visible = null;

      onClose();
    }
  };

  console.log("onSubmit function:", onSubmit);

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={
        showFooter && (
          <>
            <Button onClick={onClose}>Cancel</Button>
            {!readOnly && !onDelete && (
              <Button type="primary" htmlType="submit" form="custom-modal-form">
                {submitText}
              </Button>
            )}
            {onDelete && (
              <Button
                type="primary"
                danger
                // className="  text-white"
                onClick={handleOk} // Handle delete action directly
              >
                Delete
              </Button>
            )}
          </>
        )
      }
    >
      <form id="custom-modal-form" onSubmit={handleOk}>
        {content}
      </form>
    </Modal>
  );
};

export default CustomModal;
